import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ActionIcon, Center,
} from '@mantine/core';

import { NARROW_COLUMN_STYLES } from './constants';

export default function useColEditSchema({
    onEdit,
    currentItem,
}) {
    const colEditSchema = {
        accessor: 'controls-edit',
        style: NARROW_COLUMN_STYLES,
        title: (
            <Center>
                <FontAwesomeIcon icon="pencil-alt" />
            </Center>
        ),
        render: ({ row }) => (
            <Center>
                <ActionIcon
                    color="blue"
                    variant={currentItem?.id === row.id ? 'filled' : 'light'}
                    size="sm"
                    data-id={row.id}
                    data-title={row.title}
                    data-value={row.value}
                    onClick={onEdit}
                >
                    <FontAwesomeIcon icon="pencil-alt" />
                </ActionIcon>
            </Center>
        ),
    };

    return colEditSchema;
}
